module.exports = __webpack_public_path__ + "assets/GTAmerica-ExpandedBlack.eot";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExpandedBlack.eot
// module id = 998
// module chunks = 19